import * as _ from 'underscore';

import { L10n } from '../L10n/L10n';
import { Module } from '../Module';
import {
  IDailySchedule,
  IHourlySchedule,
  IMonthlySchedule,
  IWeeklySchedule,
  ScheduleActions,
  ScheduleLastDayOfMonth,
} from '../../schedule/types/ISchedule';
import { getSessionManagementServiceInstance, SessionManagementService } from '../../sessionManagement/SessionManagementService';

export interface IScheduleViewModel extends IScheduleFrequencyViewModel {
  id?: string;  // Will be undefined for new schedules
  name: string;
  priority: number;
  parallel: boolean;
  scheduledAction: string;
}

export interface IScheduleFrequencyViewModel {
  scheduleType: string;
  daily: IDailySchedule;
  hourly: IHourlySchedule;
  weekly: IWeeklySchedule;
  monthly: IMonthlySchedule;
  frequencyOptions: IFrequencyOption[];
}

export interface ICreateOrEditScheduleScope extends ng.IScope {
  scheduleActions: string[];
  hourlyFrequencies: ICreateOrEditScheduleSelectOption[];
  daysOfMonth: ICreateOrEditScheduleSelectOption[];
  scheduleViewModel: IScheduleViewModel;
  flowsOnServerEnabled: boolean;
}

export interface ICreateOrEditScheduleSelectOption {
  label: string;
  value: any;
}

export interface IFrequencyOption {
  value: string;
  locKey: string;
}

export const FrequencyOption = {
  Monthly: { value: 'Monthly', locKey: 'monthly' },
  Weekly: { value: 'Weekly', locKey: 'weekly' },
  Daily: { value: 'Daily', locKey: 'daily' },
  Hourly: { value: 'Hourly', locKey: 'hourly' }
};

export class CreateOrEditScheduleCtrl {

  public static $inject = [
    '$scope',
    '$translate'
  ];

  constructor(
            $scope: ICreateOrEditScheduleScope,
    private $translate: ng.translate.ITranslateService
  ) {
    const flowsOnServerEnabled = getSessionManagementServiceInstance().flowsOnServerEnabled();
    let scheduleActions = _.values(ScheduleActions);
    if (!flowsOnServerEnabled) {
      scheduleActions = _.without(scheduleActions, ScheduleActions.Flow);
    }
    $scope.scheduleActions = scheduleActions;
    $scope.hourlyFrequencies = this.hourlyFrequencies();
    $scope.daysOfMonth = this.daysOfMonth();
    $scope.flowsOnServerEnabled = flowsOnServerEnabled;
  }

  private hourlyFrequencies() {
    const hourlyFrequencies: ICreateOrEditScheduleSelectOption[] = [];
    _.each([ 15, 30 ], (minutes: number) => {
      hourlyFrequencies.push({
        label: this.$translate.instant('minutes', { MINUTES: minutes }, L10n.Interpolations.Count),
        value: minutes
      });
    });
    _.each([ 1, 2, 4, 6, 8, 12 ], (hours: number) => {
      hourlyFrequencies.push({
        label: this.$translate.instant('hours', { HOURS: hours }, L10n.Interpolations.Count),
        value: hours * 60
      });
    });
    return hourlyFrequencies;
  }

  private daysOfMonth() {
    const daysOfMonth: ICreateOrEditScheduleSelectOption[] = [];
    _.each(_.range(1, 32), (day: number) => {
      daysOfMonth.push({
        label: this.$translate.instant('dayOfMonth', { DAY: day }, L10n.Interpolations.Count),
        value: '' + day
      });
    });
    daysOfMonth.push({ label: this.$translate.instant('last'), value: ScheduleLastDayOfMonth });
    return daysOfMonth;
  }

}

Module.instance().controller('CreateOrEditScheduleCtrl', CreateOrEditScheduleCtrl);
